var exports = {
  "Sc": "Checkbox__2nVH95",
  "az": "Box__ml3Ke2",
  "wy": "Box_1__mu80x2",
  "pv": "Box_2__CWE4JV",
  "w9": "Box_3__qa_wi2",
  "pQ": "Box_4__iwExFs",
  "N_": "Link__0XsADl",
  "EY": "Text__PieXIM",
};

module.exports = exports;
